import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MailService {

  constructor(private http: HttpClient) { }

  sendDynamicEmail(config: any) {
    return this.http.post<any>(`${environment.url_api}email`, {config})
  }

  sendDynamicTemplateEmail(config: any) {
    return this.http.post<any>(`${environment.url_api}dynamic-email`, {config})
  }
}
